import { Container } from './Container';
import { SendButton } from './SendButton';
import { ChatInputTextarea } from './Textarea';
import { ChatInputIcon } from './Icon';

export default {
  Container,
  SendButton,
  Textarea: ChatInputTextarea,
  Icon: ChatInputIcon,
};
